import { Button, Paper, TextField, Typography } from "@material-ui/core";
import React from "react";
import "../Main.css";
import { isNullOrEmpty, parseDate } from "../Util";
import { InspectionGrid } from "./InspectionGrid";
import { GetBuildings, GetElevators, GetMechanics } from "../StaticVariables";

export interface Inspection {
	BuildingName: string;
	ElevatorsID: string;
	SerialNumber: string;
	Passed: boolean;
	FirstDate?: Date;
	SecondDate?: Date;
	ThirdDate?: Date;
	ExpirationDate?: Date;
	Modified: boolean;
	InspectionsID: string;
	SecondPassed: boolean;
	ThirdPassed: boolean;
	ID: string;
	MechanicID: string;
	Company: string;
}

export function Inspections() {
	const [inspections, setInspections] = React.useState([] as Array<Inspection>);
	const [building, setBuilding] = React.useState("");
	const [serial, setSerial] = React.useState("");

	const preload = async () => {
		await GetElevators();
		await GetBuildings();
		await GetMechanics();
	};
	const getData = () => {
		fetch("Inspection/GetInspectionList", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ approved: true }),
		})
			.then((x) => x.json())
			.then((x) => {
				console.log(x);
				const insps = x.map((y: any) => {
					return {
						BuildingName: y.building_name,
						ElevatorsID: y.elevators_id,
						SerialNumber: y.serial_number,
						Passed: y.is_passed,
						FirstDate: parseDate(y.first_inspection),
						SecondDate: parseDate(y.second_inspection),
						ThirdDate: parseDate(y.third_inspection),
						ExpirationDate: parseDate(y.expiration_date),
						InspectionsID: y.inspections_id,
						SecondPassed: y.is_second_passed,
						ThirdPassed: y.is_third_passed,
						MechanicID: y.mechanic_id,
						Company: y.company,
						ID: Math.random().toString().substring(2),
					} as Inspection;
				});
				setInspections(insps);
			});
	};
	React.useEffect(() => {
		preload().then((x) => getData());
		// getData();
	}, []);
	const save = () => {
		const m = inspections.filter((x) => x.Modified);
		console.log(m);
		fetch("Inspection/SaveInspections", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify(m),
		}).then((x) => getData());
	};

	const getInspections = () => {
		return inspections.filter((x) => {
			return (isNullOrEmpty(building) || x.BuildingName.toLocaleLowerCase().includes(building.toLowerCase())) && (isNullOrEmpty(serial) || x.SerialNumber.toLowerCase().includes(serial.toLowerCase()));
		});
	};

	return (
		<div style={{ backgroundColor: "#ebebeb", padding: "4px", flex: 1, display: "flex", flexDirection: "column", maxHeight: "100%" }}>
			<div style={{ flex: "1 1 100%", display: "flex", overflowY: "auto" }}>
				<Paper style={{ flex: 1, overflowY: "auto" }}>
					<Typography variant="h5" style={{ padding: "8px" }}>
						Inspections{" "}
						<Button variant="contained" color="primary" onClick={save}>
							Save
						</Button>{" "}
						<TextField label="Serial Number" onChange={(x: any) => setSerial(x.target.value)} style={{ float: "right" }}></TextField>
						<TextField label="Building Name" onChange={(x: any) => setBuilding(x.target.value)} style={{ float: "right", marginRight: "8px" }}></TextField>
					</Typography>
					<InspectionGrid Data={getInspections()}></InspectionGrid>
				</Paper>
			</div>
		</div>
	);
}
